// Image utility — all images come from S3 via backend API.
// No local static fallback; products must have image_url set in Django admin.

export const PLACEHOLDER = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22400%22 height=%22400%22%3E%3Crect width=%22400%22 height=%22400%22 fill=%22%23f0f0f0%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 dominant-baseline=%22middle%22 text-anchor=%22middle%22 font-size=%2218%22 fill=%22%23aaa%22%3ENo image%3C/text%3E%3C/svg%3E';

/**
 * Get all product images from S3 URLs.
 * @param {string} _slug - unused, kept for API compatibility
 * @param {string[]} backendImages - Array of image_url values from the backend
 * @returns {string[]}
 */
export const getProductImages = (_slug, backendImages = []) => {
  const valid = backendImages.filter(url => url && url.startsWith('http'));
  return valid.length > 0 ? valid : [PLACEHOLDER];
};

/**
 * Get primary product image URL.
 * Accepts a product object or a plain URL string.
 * @param {string|object} input - image_url string or product object
 * @returns {string}
 */
export const getImageUrl = (input) => {
  if (!input) return PLACEHOLDER;

  // Accept a full product object — read image_url
  if (typeof input === 'object') {
    const url = input.image_url || '';
    return url && url.startsWith('http') ? url : PLACEHOLDER;
  }

  // Accept a plain URL string
  return input.startsWith('http') ? input : PLACEHOLDER;
};

/**
 * Preload images for performance.
 */
export const preloadImages = (imageUrls) => {
  imageUrls.forEach(url => {
    if (url && url.startsWith('http')) {
      const img = new Image();
      img.src = url;
    }
  });
};

export default getImageUrl;

